// extracted by mini-css-extract-plugin
export default {"question":"Question_question__zv9Po","number":"Question_number__-ErIn","mainWrapper":"Question_mainWrapper__fHpNB","addAnswerButton":"Question_addAnswerButton__y1Cqj"};